<template>
  <div class="tworderdone">
    <div class="container">
      <!-- Content here -->
      <br />

      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">委託單已經成立</a>
      </nav>

      <br />
      <div v-if="this.$route.query.orderId && this.$route.query.userId">
        <div class="card">
          <div class="title">付款詳情</div>
          <div class="card-body">
            <p>
              訂單編號:
              <b>{{ displayViews.order_id }}</b>
            </p>
            <p class="text-danger">
              總付款金額:
              <b>{{ displayViews.total_price }}元</b>
            </p>
            <p>繳費期限:{{ displayViews.pay.expire_date }}</p>
            <!-- <p>交易編號:{{displayViews.payment_id}}</p> -->
            <p>繳費銀行代碼:{{ displayViews.pay.payment_bank_code }}</p>
            <p>繳費虛擬帳號:{{ displayViews.pay.paymentv_account }}</p>
            <button
              class="btn btn-info btn-lg btn-block"
              v-clipboard:copy="displayViews.pay.paymentv_account"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              複製繳費虛擬帳號
            </button>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="card">
          <div class="title">資料錯誤，請聯絡客服!</div>
          <div class="card-body"></div>
        </div>
      </div>

      <br />
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<style type="text/css"></style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
export default {
  name: 'tworderdone',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      fbEndpoint: 'https://m.me/2266831083395361',
      displayViews: null,
      isLoading: true,
      userId: '',
      userImage: '',
      userName: '',
      chatbotFbUrl:
        'https://api.chatfuel.com/bots/5cf9f337dd449f0001fbc05a/users/',
      chatfuelToken:
        'uOBx3XXkpYjq1uA1O7FBzN1of2RrFwFpllox0CLMofvSfiXrgv6SkEHZAme183nZ',
    }
  },
  watch: {},
  methods: {
    clearShoppingCart: function () {
      const vm = this
      vm.$store.prodInfos = []
      localStorage.setItem('twProducts', JSON.stringify([]))
      vm.$forceUpdate()
    },
    invokeGetTwOrderByOrderId: function (orderId) {
      const vm = this
      ;(async function postapi() {
        vm.isLoading = true

        let formData = {
          orderId: orderId,
        }
        await axios
          .post(vm.apiUrl + 'GetTwOrderByOrderId', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            if (Object.keys(response.data).length != 0) {
              vm.$toast.open({
                message: '讀取付款資訊完成!',
                type: 'success',
              })
              vm.displayViews = response.data

              vm.sendBidFbMessageConsumer(
                localStorage.userId,
                '5e295c09c230020001b8f1ad',
                '&orderId=' +
                  localStorage.orderId +
                  '&payment_id=' +
                  vm.displayViews.pay.payment_id +
                  '&payment_bank_code=' +
                  vm.displayViews.pay.payment_bank_code +
                  '&paymentv_account=' +
                  vm.displayViews.pay.paymentv_account +
                  '&price=' +
                  vm.displayViews.total_price +
                  '&expire_date=' +
                  vm.displayViews.pay.expire_date
              )
            }
            vm.isLoading = false
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '失敗: ' + error,
              type: 'error',
            })
            vm.isLoading = false
          })
      })()
    },
    sendBidFbMessageConsumer: function (userId, blockId, messageData) {
      const vm = this

      ;(async function post() {
        let formData = {}
        await axios
          .post(
            vm.chatbotFbUrl +
              userId +
              '/send?chatfuel_token=' +
              vm.chatfuelToken +
              '&chatfuel_block_id=' +
              blockId +
              messageData,
            formData,
            {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
              },
            }
          )
          .then(function (response) {
            var data = response.data
            if (data.result == 'ok') {
              vm.$toast.open({
                message: '發送訊息!',
                type: 'success',
              })
            }
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '發送訊息失敗: ' + error,
              type: 'error',
            })
          })
      })()
    },
    onCopy: function () {
      const vm = this
      vm.$toast.open({
        message: '已幫您複製繳費虛擬帳號!',
        type: 'success',
      })
    },
    onError: function () {
      const vm = this
      vm.$toast.open({
        message: '複製失敗!',
        type: 'success',
      })
    },
  },
  mounted() {
    const vm = this
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    vm.clearShoppingCart()

    if (vm.$route.query.orderId && vm.$route.query.userId) {
      localStorage.orderId = decodeURI(vm.$route.query.orderId)
      localStorage.userId = decodeURI(vm.$route.query.userId)
      vm.invokeGetTwOrderByOrderId(localStorage.orderId, localStorage.userId)
    } else {
      vm.$toast.open({
        message: '資料錯誤，請聯絡客服!',
        type: 'error',
      })
      vm.isLoading = false
    }
  },
}
</script>
